import { v4 } from 'uuid';

export const newGUID = (): string => {
  return v4().toString();
};
